import React from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, FormControlLabel } from '@material-ui/core';
import { useStyles } from './MapLayerControls.styles';

const LAYER_CONFIG = [
  { key: 'drivers', label: 'Drivers', color: '#2176ea' },
  { key: 'restaurants', label: 'Restaurants', color: '#4caf50' },
];

const ORDER_FILTER_CONFIG = [
  { key: 'unassignedOnly', label: 'Unassigned only' },
  { key: 'pickupSoon', label: 'Pickup ≤ 30 min' },
];

export default function MapLayerControls({ layerToggles, onLayerToggle }) {
  const classes = useStyles();

  return (
    <Box className={classes.card}>
      {LAYER_CONFIG.map(({ key, label, color }) => (
        <FormControlLabel
          key={key}
          className={classes.label}
          control={
            <Checkbox
              className={classes.checkbox}
              size="small"
              checked={!!layerToggles[key]}
              onChange={() => onLayerToggle(key)}
              style={{ color }}
            />
          }
          label={
            <>
              <span
                className={classes.swatch}
                style={{ background: color }}
              />
              {label}
            </>
          }
        />
      ))}
      <Box className={classes.orderGroup}>
        <FormControlLabel
          className={classes.label}
          control={
            <Checkbox
              className={classes.checkbox}
              size="small"
              checked={!!layerToggles.orders}
              onChange={() => onLayerToggle('orders')}
              style={{ color: '#ff9800' }}
            />
          }
          label={
            <>
              <span
                className={classes.swatch}
                style={{ background: '#ff9800' }}
              />
              Active Orders
            </>
          }
        />
        {layerToggles.orders && (
          <Box className={classes.orderFilters}>
            {ORDER_FILTER_CONFIG.map(({ key, label }) => (
              <FormControlLabel
                key={key}
                className={classes.filterLabel}
                control={
                  <Checkbox
                    className={classes.checkbox}
                    size="small"
                    checked={!!layerToggles[key]}
                    onChange={() => onLayerToggle(key)}
                    style={{ color: '#ff9800' }}
                  />
                }
                label={label}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}

MapLayerControls.propTypes = {
  layerToggles: PropTypes.shape({
    drivers: PropTypes.bool,
    restaurants: PropTypes.bool,
    orders: PropTypes.bool,
    unassignedOnly: PropTypes.bool,
    pickupSoon: PropTypes.bool,
  }).isRequired,
  onLayerToggle: PropTypes.func.isRequired,
};
